import { IconButton, Grow, Paper } from '@mui/material';
import { ChevronSmallDownIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiAutocompleteOverrides = {
  MuiAutocomplete: {
    defaultProps: {
      PaperComponent: props => /*#__PURE__*/jsx(Grow, {
        in: true,
        children: /*#__PURE__*/jsx(Paper, {
          ...props
        })
      }),
      disableCloseOnSelect: false,
      disableClearable: true,
      size: 'medium',
      ChipProps: {
        color: 'blue',
        size: 'medium'
      },
      slotProps: {
        popupIndicator: {
          component: props => /*#__PURE__*/jsx(IconButton, {
            ...props,
            disableRipple: true,
            disableFocusRipple: true,
            disableTouchRipple: true,
            sx: {
              '&&': {
                padding: 0
              },
              '&&:hover': {
                background: 'transparent'
              }
            },
            children: /*#__PURE__*/jsx(ChevronSmallDownIcon, {
              fontSize: "medium"
            })
          })
        },
        paper: {
          elevation: 8
        }
      }
    },
    styleOverrides: {
      groupLabel: ({
        theme
      }) => ({
        ...theme.typography.subheader,
        fontSize: 'inherit',
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        cursor: 'default'
      }),
      tag: {
        margin: 0
      },
      listbox: ({
        theme
      }) => ({
        padding: 0,
        '& .MuiAutocomplete-option': {
          ...theme.typography.body01,
          minHeight: theme.spacing(5),
          [theme.breakpoints.up('sm')]: {
            minHeight: theme.spacing(5)
          }
        }
      }),
      input: {
        '&.MuiInput-input': {
          padding: 0
        }
      },
      inputRoot: ({
        theme
      }) => ({
        padding: theme.spacing(1.25),
        gap: theme.spacing(1),
        '.MuiInputAdornment-positionStart .MuiSvgIcon-root': {
          margin: 0
        }
      })
    }
  }
};

export { MuiAutocompleteOverrides };
